// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aiR8","left":"styles_left__21dMX"};